import { FC } from "react";
import { Plus } from "lucide-react";
import AuthButton from "./AuthButton";
import { useChatContext } from "./App";
import { HistoryDropdown } from "./HistoryDropdown";

const Header: FC = () => {
  const { startNewConversation, loadConversation, conversationId } = useChatContext();

  return (
    <div className="fixed top-0 left-0 right-0 bg-base-100 border-b border-base-300 z-20 flex items-center justify-between px-4 h-10 shrink-0">
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={startNewConversation}
          className="btn btn-ghost text-base-content/70 hover:bg-base-300 hover:border-base-300 btn-sm flex items-center gap-2 px-2"
          title="Nouvelle conversation"
        >
          <Plus className="size-5" />
          <span className="hidden sm:inline">Nouvelle conversation</span>
        </button>

        <div className="w-px h-4 bg-base-300 mx-1" />

        <HistoryDropdown
          currentConversationId={conversationId}
          onSelectConversation={loadConversation}
        />
      </div>

      <AuthButton />
    </div>
  );
};

export default Header;
